import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getTodayResult = async () => {
  const { data } = await client.get("/results/today");
  return data;
};

export const getPreviousResults = async ({ page = 1, limit = 20, year, month } = {}) => {
  const params = { page, limit };
  if (year) params.year = year;
  if (month) params.month = month;
  const { data } = await client.get("/results/previous", { params });
  return data;
};

export const getLatestCommonNumber = async () => {
  const { data } = await client.get("/common-number/latest");
  return data;
};

export const getPrediction = async () => {
  const { data } = await client.get("/analytics/prediction");
  return data;
};

export const getFrequency = async () => {
  const { data } = await client.get("/analytics/frequency");
  return data;
};

export const getResultByDate = async (dateSort) => {
  const { data } = await client.get("/results/by-date", {
    params: { date_sort: dateSort },
  });
  return data;
};

export default client;
